import { getFilteredTree } from './get-filtered-tree.js';
import { getMappedTree } from './get-mapped-tree.js';
import type { TreeMapFormatter } from '../types/internal.js';
import type { TreeMapRootNode } from '../types/treemap.js';

export function mapToInternalTree(
  tree: TreeMapRootNode,
  formatter: TreeMapFormatter,
  unit?: string,
) {
  const mappedTree = getMappedTree(tree, formatter, unit);
  const filteredTree = getFilteredTree(mappedTree);
  return filteredTree;
}
